import { styled } from "styled-components";
import { useConfigControls, useConfigAr } from "../../hooks/config";
import ButtonGroup from "../ButtonGroup";
import Button from "../Button";
import { ArQrButton } from "../ArButton";
import Icon from "../Icon";

const ButtonsContainer = styled.div`
  position: absolute;
  bottom: 0.5rem;
  min-height: 40px;
  width: 100%;
	padding: 0 1rem;
  display: flex;
	align-items: center;
	justify-content: ${({ $position }) => $position || "flex-end"};
	gap: 6px;
`;

const ViewerButtons = ({ zoomIn, zoomOut, renderingApi }) => {
	//TODO: remove controls.ar once Corsair is changed or on fixed version
	const { zoom, position, enabled: buttonsEnabled, ar } = useConfigControls();
	const { enabled: arEnabled } = useConfigAr();
	const showAr = arEnabled !== false && ar !== false

	return (
		(buttonsEnabled !== false) && <ButtonsContainer $position={position}>
			{!!zoom && <ButtonGroup>
				<Button onClick={zoomOut}><Icon icon="minus"/></Button>
				{/*<Button onClick={zoomReset}>o</Button>*/}
				<Button onClick={zoomIn}><Icon icon="plus"/></Button>
			</ButtonGroup>}

			{showAr && <ArQrButton renderingApi={renderingApi}/>}
			</ButtonsContainer>
	);
};

export default ViewerButtons;
